// This file is intended for JS that should be initialized as quickly as possible on page load. No modules (such as jQuery) are available

// `config.classes` will not be ready in time, so we unfortunately need this one duplicate
const classes = {
  active: 'tw-on',
}

;(function init() {
  updateCustomYotpoComponents()
})()

function updateCustomYotpoComponents() {
  const selectors = {
    active: '[data-utility="yotpo-active"]',
    points: '[data-utility="yotpo-points"]',
  }

  const pointsEl = document.querySelector(selectors.points)
  const activeEl = document.querySelector(selectors.active)

  const points_balance = sessionStorage.getItem('yotpo_points_balance')

  if (points_balance) {
    if (pointsEl) {
      pointsEl.innerText = points_balance
    }

    if (activeEl) {
      const customerHasPoints = points_balance > 0

      if (customerHasPoints) {
        activeEl.classList.add(classes.active)
      } else {
        activeEl.classList.remove(classes.active)
      }
    }
  }
}
